export function getText(value) {
  switch (value) {
    case 'my-boards': {
      return 'My Boards'
    }
    case 'other-boards': {
      return 'Other Boards'
    }
    case 'private': {
      return 'Private'
    }
    default:
  }
}
